import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function PurchaseSalesInventory() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
